import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
//import { InputIcon } from "primereact/inputicon";

import "./DatabaseDialog.css";

const DatabaseDialog = ({ visible, onHide, database }) => {
  const [collections, setCollections] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState(null);
  //eslint-disable-next-line
  const [collectionSchema, setCollectionSchema] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const toast = useRef(null);

  useEffect(() => {
    if (visible) {
      const fetchCollections = async () => {
        try {
          setCollections(Object.entries(database.collectionSizes));
        } catch (error) {
          console.error("Error fetching collections:", error);
        }
      };

      fetchCollections();
    }
  }, [visible, database]);

  const fetchCollectionSchema = (collection) => {
    setSelectedCollection(collection);
    setCollectionSchema(collection[1]);
  };

  return (
    <>
      <Toast ref={toast} />
      <Dialog
        header={`Collections in ${database.databaseName}`}
        visible={visible}
        style={{
          width: window.innerWidth > 768 ? "90vw" : "95vw",
          height: window.innerWidth > 768 ? "80vh" : "95vh",
          maxWidth: "1200px",
        }}
        onHide={onHide}
        className="database-dialog"
      >
        <div className="dialog-content">
          <div className="tables-list">
            <IconField iconPosition="left" className="table-search-container">
              <InputText
                placeholder="Search collections"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="table-search"
              />
            </IconField>
            <div className="collections-list">
              {collections
                .filter((collection) =>
                  collection[0].toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((collection, index) => (
                  <div key={index} className="table-item">
                    <Button
                      label={collection[0]}
                      onClick={() => fetchCollectionSchema(collection)}
                      className="p-button-text table-button"
                      style={{ color: "#0D2E4D", fontSize: "1rem" }}
                    />
                  </div>
                ))}
            </div>
          </div>
          <div className="table-schema">
            {selectedCollection ? (
              <div>
                <h3>Size of {selectedCollection[0]}</h3>
                <div className="schema-table-container">
                  <table className="schema-table">
                    <thead>
                      <tr>
                        <th>Collection Name</th>
                        <th>Size</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{selectedCollection[0]}</td>
                        <td>{selectedCollection[1]}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <p>Select a collection to view its size.</p>
            )}
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default DatabaseDialog;
